import React from "react";
import AdminEntityList from "@/components/admin/AdminEntityList";

const fields = [
  { key: "title", label: "Title", required: true },
  { key: "slug", label: "Slug (auto if empty)" },
  { key: "description", label: "Description", type: "textarea", rows: 3 },
  { key: "editorial_intro", label: "Editorial intro", type: "textarea", rows: 4 },
  { key: "featured_image", label: "Featured image URL" },
  { key: "interview_slugs", label: "Interview slugs (ordered)", type: "list" },
  { key: "topic_slugs", label: "Related topic slugs", type: "list" },
  { key: "industry_slugs", label: "Related industry slugs", type: "list" },
];

export default function AdminCollections() {
  return (
    <AdminEntityList
      title="Collections"
      endpoint="/admin/collections"
      listEndpoint="/collections"
      fields={fields}
      testIdBase="admin-collections"
      itemLabel={(i) => i.title}
    />
  );
}
